import React from 'react'
import { observer } from 'mobx-react-lite'
import US_STATE_PATHS from './us-state-paths'
import { STATE_NAMES } from './../../ProductAvailability.constants'

import './ProductAvailabilityMap.scss'

// DC is a few pixels wide at this scale, so it gets a callout marker off the coast.
const DC_CENTER = { x: 880, y: 230 },
  DC_CALLOUT = { x: 930, y: 292, r: 12 }

// onSelect: an explicit tap/click/Enter, as opposed to hover or focus.
const ProductAvailabilityMap = ({ fillFor, labelFor, activeState, onActivate, onSelect }) => {
  const handlers = code => ({
    tabIndex: 0,
    role: 'button',
    'aria-label': labelFor(code),
    'data-state': code,
    onMouseEnter: () => onActivate(code),
    onFocus: () => onActivate(code),
    onClick: () => onSelect(code),
    onKeyDown: event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        onSelect(code)
      }
    },
  })

  return (
    <div className='ProductAvailabilityMapComponent'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 1000 589'
        role='group'
        aria-label='United States map of product availability'
      >
        {Object.keys(US_STATE_PATHS)
          .filter(code => code !== 'DC')
          .map(code => (
            <path
              key={code}
              d={US_STATE_PATHS[code]}
              className='state-shape'
              style={{ fill: fillFor(code) }}
              {...handlers(code)}
            >
              <title>{STATE_NAMES[code]}</title>
            </path>
          ))}

        <path
          d={US_STATE_PATHS.DC}
          className='state-shape dc-shape'
          style={{ fill: fillFor('DC') }}
          aria-hidden='true'
          onMouseEnter={() => onActivate('DC')}
          onClick={() => onSelect('DC')}
        />
        <line x1={DC_CENTER.x} y1={DC_CENTER.y} x2={DC_CALLOUT.x} y2={DC_CALLOUT.y} className='dc-leader' />
        <g className='dc-callout' {...handlers('DC')}>
          <title>{STATE_NAMES.DC}</title>
          <circle cx={DC_CALLOUT.x} cy={DC_CALLOUT.y} r={DC_CALLOUT.r} style={{ fill: fillFor('DC') }} />
          <text x={DC_CALLOUT.x + DC_CALLOUT.r + 4} y={DC_CALLOUT.y + 4}>
            DC
          </text>
        </g>

        {activeState && activeState !== 'DC' && US_STATE_PATHS[activeState] ? (
          <path d={US_STATE_PATHS[activeState]} className='state-outline' aria-hidden='true' />
        ) : activeState === 'DC' ? (
          <circle cx={DC_CALLOUT.x} cy={DC_CALLOUT.y} r={DC_CALLOUT.r} className='state-outline' aria-hidden='true' />
        ) : null}
      </svg>
    </div>
  )
}

export default observer(ProductAvailabilityMap)
